<template>
  <div class="wrapper">
    <ul class="breadcrumbs">
      <li class="breadcrumbs-item">
        <span class="breadcrumbs_first">Project: {{project}}</span>
      </li>
      <li class="breadcrumbs-item" v-for="segment of path"
          :key="segment.name">
        <span class="breadcrumbs__arrow">&raquo;</span>
        <router-link class="breadcrumbs-link"
                     :to="segment.path">{{segment.label}}
        </router-link>
      </li>
      <li class="breadcrumbs-item">
        <span class="breadcrumbs__arrow">&raquo;</span>
        <span class="breadcrumbs_current">{{lastSegmentLabel}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import TheNavbar from "./TheNavbar"

const BRIEF_CONTENT_ROUTE_NAMES = [
  'BriefStrategy', 'BriefReporting', 'BriefStrategyPrint', 'BriefReportingPrint', 'BriefComparison',
  'BriefComparisonPrint', 'CreationTab', 'CreationTabPrint'
]
const USER_MANAGER_ROUTE_NAMES = [
  'UserTab', 'AgencyRolesTab', 'ClientRolesTab'
]
/**
 * Base component for displaying breadcrumb. Used in {@link TheNavbar}
 */
export default {
  name: 'BaseBreadCrumbs',
  mounted () {
    this.calculatePath()
    document.addEventListener('backbutton', this.calculatePath())
  },
  beforeDestroy () {
    document.removeEventListener('backbutton', this.calculatePath())
  },
  data () {
    return {
      lastSegment: {},
      path: [],
      documentObserver: null
    }
  },
  watch: {
    $route () {
      this.calculatePath()
    },
    menuItems: {
      handler () {
        this.calculatePath()
      },
      deep: true
    },
    filteredAdminRoutes: {
      handler () {
        this.calculatePath()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      selectedClient: 'selectedClient'
    }),
    ...mapState('breadcrumb', {
      briefName: 'briefName'
    }),
    project () {
      return _.get(this.selectedClient, 'name', '')
    },
    /**
     * return last past segment for breadcrumb
     * for brief content there is saved in store briefName ('breadcrumb' module)
     * @returns {string|*|string}
     */
    lastSegmentLabel () {
      const savedSegment = BRIEF_CONTENT_ROUTE_NAMES.includes(this.$route.name)
        ? this.briefName
        : USER_MANAGER_ROUTE_NAMES.includes(this.$route.name) ? 'Edit' : ''
      if (savedSegment) return savedSegment
      else return this.lastSegment.label || ''
    }
  },
  methods: {
    setTitle () {
      this.documentObserver && clearInterval(this.documentObserver)
      if (this.lastSegment.name !== 'content-briefs') {
        const title = this.lastSegment.title ? this.lastSegment.title : this.lastSegment.label
        const newTitle = `${title} | Audience Key`
        document.title = newTitle

        this.documentObserver = setInterval(() => {
          if (document.title !== newTitle) {
            document.title = newTitle
          }
        }, 500)
      }
    },
    /**
     * this method parses current path and forms array for breadcrumb using RouteNameHelper module as source of all existing routes
     */
    calculatePath () {
      let routePath = this.$route.path.split('/').filter(item => !_.isEmpty(item))
      this.path = []
      if (routePath.length > 0) {
        this.findRouteBySegmentName(routePath, this.menuItems, '')
      }
      this.lastSegment = this.path.pop()
      this.setTitle()
    },
    findRouteBySegmentName (pathFromRoute, routes, parentPath) {
      const topRoute = pathFromRoute.shift()
      let route = _.cloneDeep(routes.find(item => item.name === topRoute || item.isParam))
      if (route) {
        parentPath += route.path.startsWith('/') ? route.path : '/' + route.path

        route.path = parentPath
      } else {
        route = {
          name: topRoute,
          label: '',
          path: `${parentPath}/${topRoute}`
        }
      }
      if (!route.isHiddenInBreadcrumbs) {
        this.path.push(route)
      }
      if (pathFromRoute.length > 0 && route.children) {
        this.findRouteBySegmentName(pathFromRoute, route.children, parentPath)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .breadcrumbs {
    margin: 0;

    &__arrow{
      margin-right: 15px;
      font-size: 14px;
    }

    &_current {
      color: $rfx-dark-march;
      opacity: 0.8;
    }

    &_first {
      color: $rfx-dark-march;
      font-weight: 500;
    }
  }
</style>
